(function () {
  'use strict';

  // Namespaced key — generic names like "recently_viewed_products" are
  // commonly used by themes/apps to store a different shape of data
  // (e.g. full product objects instead of handle strings), which causes
  // silent breakage if two scripts share the same key.
  var STORAGE_KEY = 'rvp:custom:handles:v1';
  var MAX_STORED = 20;

  // The element inside sections/recently-viewed-item.liquid whose innerHTML
  // gets extracted from the fetched page. Deliberately NOT using Shopify's
  // Section Rendering API (?section_id=...) here — that parameter doesn't
  // reliably resolve against an alternate template (`view=...`) on every
  // store, so instead we fetch the full alternate-template page and pull
  // just this element out client-side, which only depends on the
  // alternate template resolving at all (already confirmed working).
  var ITEM_ROOT_SELECTOR = '[data-rvp-item-root]';
  var domParser = new DOMParser();

  // Normalizes a stored entry to a plain handle string. Handles legacy or
  // foreign data shapes defensively (e.g. { handle: '...' } objects, or
  // anything unexpected) instead of letting them reach the fetch URL.
  function toHandle(entry) {
    if (typeof entry === 'string') return entry;
    if (entry && typeof entry === 'object' && typeof entry.handle === 'string') {
      return entry.handle;
    }
    return null;
  }

  function getStored() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(list)) return [];
      var handles = [];
      for (var i = 0; i < list.length; i++) {
        var handle = toHandle(list[i]);
        if (handle) handles.push(handle);
      }
      return handles;
    } catch (e) {
      return [];
    }
  }

  function setStored(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      // localStorage unavailable (private mode, quota, etc.) — fail silently
    }
  }

  function recordView(handle) {
    if (!handle) return;
    var list = getStored().filter(function (h) {
      return h !== handle;
    });
    list.unshift(handle);
    if (list.length > MAX_STORED) list = list.slice(0, MAX_STORED);
    setStored(list);
  }

  // 1) Record the current product view, if this page set one.
  if (window.__recentlyViewedProduct && window.__recentlyViewedProduct.handle) {
    recordView(window.__recentlyViewedProduct.handle);
  }

  // 2) Render every <recently-viewed-products> block on the page.
  function renderSection(el) {
    var grid = el.querySelector('[data-recently-viewed-grid]');
    var emptyState = el.querySelector('[data-recently-viewed-empty]');
    var max = parseInt(el.getAttribute('data-max-products'), 10) || 4;
    var currentHandle =
      window.__recentlyViewedProduct && window.__recentlyViewedProduct.handle;

    var handles = getStored()
      .filter(function (h) {
        return h !== currentHandle;
      })
      .slice(0, max);

    function showEmpty() {
      if (el.classList.contains('recently-viewed-products--hide-empty')) {
        el.hidden = true;
      } else if (emptyState) {
        emptyState.hidden = false;
      }
    }

    if (!handles.length) {
      showEmpty();
      return;
    }

    var requests = handles.map(function (handle) {
      var url = '/products/' + encodeURIComponent(handle) + '?view=recently-viewed-item';
      return fetch(url)
        .then(function (res) {
          return res.ok ? res.text() : '';
        })
        .then(function (html) {
          if (!html) return '';
          try {
            var doc = domParser.parseFromString(html, 'text/html');
            var root = doc.querySelector(ITEM_ROOT_SELECTOR);
            return root ? root.innerHTML : '';
          } catch (e) {
            return '';
          }
        })
        .catch(function () {
          return '';
        });
    });

    Promise.all(requests).then(function (htmlChunks) {
      var frag = document.createDocumentFragment();

      htmlChunks.forEach(function (html) {
        if (!html) return;
        var wrapper = document.createElement('div');
        wrapper.className = 'recently-viewed-products__item';
        wrapper.innerHTML = html.trim();
        frag.appendChild(wrapper);
      });

      if (!frag.childNodes.length) {
        showEmpty();
        return;
      }

      grid.appendChild(frag);
    });
  }

  function init() {
    var sections = document.querySelectorAll('recently-viewed-products');
    Array.prototype.forEach.call(sections, renderSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
